import React, { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import globalMsg from 'messages';
import ui from 'modules/ui';

import './settingsMobileOverlay.scss';

const {
    components: { OddFormatSelectMobile, OddsStatisticSelectMobile },
} = ui;

interface Props {
    container: RefObject<HTMLDivElement>;
}

const SettingsMobileOverlay: React.FC<Props> = ({ container }) => {
    return (
        <div styleName="container" ref={container}>
            <div styleName="title">
                <FormattedMessage {...globalMsg.showSettings} />
            </div>
            <OddFormatSelectMobile />
            <OddsStatisticSelectMobile />
        </div>
    );
};

export default SettingsMobileOverlay;
